<template>
  <label class="t-logo-upload">
    <div class="t-logo-upload__element">
      <div class="t-logo-upload__unset" v-if="unset">
        <slot />
      </div>

      <div class="t-logo-upload__image" v-else>
        <img class="t-logo-upload__logo" :src="logo">
      </div>
    </div>

    <input
      class="t-logo-upload__input"
      type="file"
      :accept="accept"
      :disabled="disabled"
      :multiple="false"
      @change="onFileChange"
    >
  </label>
</template>

<script>
import ValidatableMixin from '../../mixins/ValidatableMixin';

export default {
  name: 't-logo-upload',
  mixins: [ValidatableMixin],

  props: {
    value: [Object, Function, window.File, String],
    dragAndDrop: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    disabled: Boolean,
    preprocess: {
      type: Function,
      required: false,
      default: (value) => value,
    },
  },

  data() {
    return {
      newValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.newValue = value;
    },
  },

  computed: {
    logo() {
      if (this.newValue instanceof Object || this.newValue instanceof window.File) {
        return URL.createObjectURL(this.newValue);
      }
      return this.newValue;
    },

    unset() {
      return !this.newValue;
    },
  },

  methods: {
    async onFileChange(event) {
      if (this.disabled) return;

      const value = event.target.files || event.dataTransfer.files;

      // User canceled.
      if (!value || !value.length) {
        return;
      }

      let file = value[0];
      file = await this.preprocess(file);

      // User canceled preprocessing.
      // TODO: maybe add a way to mark if preprocessing is required or not.
      if (!file) {
        return;
      }

      this.newValue = file;

      this.$emit('input', this.newValue);
      this.$emit('change', this.newValue);
    },
  },
};
</script>
